import React from 'react';
import { inject, observer } from 'mobx-react';
import { ProblemBusiness } from '@business/newCreateRequest/stepsItems/problem';
import { Button, NoData } from 'oned';
import { ProblemLevel } from '@common/enums/base';
import classnames from 'classnames';
var LevelOne = inject(ProblemBusiness)(observer(function (props) {
    var setProblemLevel = props.setProblemLevel, levelOneAliasList = props.levelOneAliasList, setProblemAlias = props.setProblemAlias, getServiceComboAlias = props.getServiceComboAlias, levelOneId = props.levelOneId, clearAfterStepData = props.clearAfterStepData, isAliasingView = props.isAliasingView;
    var setLevel = function (alias) {
        setProblemAlias(alias, ProblemLevel.LevelOne);
        setProblemLevel(ProblemLevel.LevelTwo);
        clearAfterStepData();
        getServiceComboAlias(ProblemLevel.LevelTwo, alias.id);
    };
    return React.createElement("div", null,
        React.createElement("div", { className: 'row' },
            React.createElement("div", { className: 'col-12' },
                React.createElement("h2", { className: 'problem-title' },
                    React.createElement("b", null, isAliasingView ? 'Where is the issue?' : 'Service category')))),
        React.createElement("div", { className: 'row' },
            levelOneAliasList.length > 0 && levelOneAliasList.map(function (alias) { return (React.createElement("div", { className: 'col-md-6 col-xs-12' },
                React.createElement(Button, { type: 'secondary', className: classnames('w-100 my-2 dsm-btn-secondary dsm-btn sc-btn f14', alias.id === levelOneId && 'active'), onClick: function () { return setLevel(alias); } }, alias.name))); }),
            !levelOneAliasList || levelOneAliasList.length === 0 &&
                React.createElement("div", { className: 'w-100 d-flex justify-content-center' },
                    React.createElement(NoData, null))));
}));
export default LevelOne;
